module.exports = __webpack_public_path__ + "static/media/kareya-saleh.d538f242.jpg";